import { alpha, darken, getContrastRatio, lighten } from "@mui/material/styles";

// Keep semantic button colors legible on the surface used by each theme.
export function readableColor(color, background, dark = false, minimum = 4.5) {
  let result = color;
  for (let step = 0; step < 20 && getContrastRatio(result, background) < minimum; step += 1)
    result = dark ? lighten(result, 0.12) : darken(result, 0.12);
  return result;
}

export default function buttonStyles({ palette, color = "primary", variant, dark = false }) {
  const surface = dark ? "#202940" : "#ffffff";
  const neutral = dark ? "#e5e7eb" : "#344767";
  const main = palette[color]?.main || neutral;
  const ink = readableColor(main, surface, dark, 5.5);
  const disabled = {
    opacity: 1,
    color: dark ? "#cbd5e1" : "#626976",
    borderColor: dark ? "#64748b" : "#cbd5e1",
    boxShadow: "none",
    pointerEvents: "none",
    ...(variant === "contained" || variant === "gradient"
      ? { background: dark ? "#374151" : "#e5e7eb" }
      : { background: "transparent" }),
  };
  const shared = {
    "&:active, &:active:focus, &:active:hover": { opacity: 1 },
    "&.Mui-focusVisible": { outline: `2px solid ${ink}`, outlineOffset: 3 },
    "&.Mui-disabled": disabled,
  };
  if (variant === "contained" || variant === "gradient") {
    const pale = color === "white" || color === "light";
    const background = pale ? main : readableColor(main, "#ffffff");
    const text = pale ? "#263244" : "#ffffff";
    const hover = darken(background, 0.1);
    let gradient;
    if (variant === "gradient" && palette.gradients?.[color] && !pale) {
      const end = readableColor(palette.gradients[color].state, "#ffffff");
      gradient = `linear-gradient(195deg, ${background}, ${end})`;
    }
    return {
      background: gradient || background,
      color: text,
      "&:hover": { background: gradient || hover, color: text, opacity: 1 },
      "&:focus:not(:hover)": { background: gradient || background, color: text },
      "&:active": { color: text, opacity: 1 },
      ...shared,
    };
  }
  return {
    color: ink,
    background: "transparent",
    ...(variant === "outlined" ? { border: `1px solid ${ink}` } : {}),
    "&:hover": { color: ink, background: alpha(ink, 0.08), borderColor: ink, opacity: 1 },
    "&:focus:not(:hover)": { color: ink, background: alpha(ink, 0.08) },
    "&:active, &:active:not(:hover)": { color: ink, background: alpha(ink, 0.14), opacity: 1 },
    ...shared,
  };
}
